/** Sentinel value for select options that trigger an upgrade prompt */
export const UPGRADE_REQUIRED_OPTION_VALUE = '__upgrade_required__';

export const AUTO_BILLING_UPGRADE_OPTION_LABEL =
  'Auto Billing (Stripe) — Upgrade required';

export const AUTO_BILLING_FILTER_UPGRADE_LABEL =
  'Auto Billing — Upgrade required';
